import { Component } from "react"
import PropTypes from "prop-types"
import { startsWith } from "lodash"

function setHeader(props) {
  if (props.View.getHeaderConfig) {
    const config = props.View.getHeaderConfig(props)
    if (config.key !== props.appHeaderKey && (!config.overridableBy || !startsWith(props.appHeaderKey, config.overridableBy))) {
      props.setHeader(config)
    }
  }
}

export default class Screen extends Component {
  static propTypes = {
    View: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  }

  constructor(props, ...args) {
    super(props, ...args)
    setHeader(props)
  }

  componentDidUpdate() {
    setHeader(this.props)
  }

  render() {
    const { View, ...props } = this.props
    return <View {...props} />
  }
}
